import * as DomBuilder from "./dom-builder.js";

/**
 *
 * @version 2026-09-01
 * @author Patrik Harag
 */
export default class ComponentTabbedPanel {

    static SELECTED_TAB_ID = 'finance-tab-analysis';

    /** @type {ComponentPanel[]} */
    #panels = [];


    /**
     *
     * @param component {ComponentPanel}
     */
    addPanel(component) {
        this.#panels.push(component);
    }

    createNode() {
        let tabsNav = DomBuilder.element('ul', { class: 'nav nav-tabs', role: 'tablist' });
        let tabsContent = DomBuilder.div({ class: 'tab-content' });

        this.#panels.forEach(component => {
            const tabId = component.getTabId();
            const tabName = component.getTabName();
            const selected = (tabId === ComponentTabbedPanel.SELECTED_TAB_ID);
            const content = component.createNode();
            this._appendTab(tabsNav, tabsContent, tabId, tabName, selected, content);
        });

        return DomBuilder.div(null, [tabsNav, tabsContent]);
    }

    _appendTab(tabsNav, tabsContent, id, title, selected, content) {
        let navId = id + "-nav";

        tabsNav.append(DomBuilder.element('li', { class: 'nav-item', role: 'presentation' }, [
            DomBuilder.element('button', {
                type: 'button',
                class: 'nav-link' + (selected ? ' active' : ''),
                id: navId,
                'data-bs-toggle': 'tab',
                'data-bs-target': '#' + id,
                role: 'tab',
                'aria-controls': id,
                'aria-selected': selected ? 'true' : 'false'
            }, title)
        ]));

        tabsContent.append(DomBuilder.div({
            class: 'tab-pane fade' + (selected ? ' show active' : ''),
            id: id,
            role: 'tabpanel',
            'aria-labelledby': navId
        }, content));
    }
}
